import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: true, name: 'filter' })
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: any, field: string): any[] {
    if (!items) return [];
    if (!searchText || searchText.length === 0) return items;

    if (Array.isArray(searchText)) {
      const selectedValues = searchText.map(option =>
        option && typeof option === 'object' && option[field] ? option[field].toLowerCase() : ''
      );
      return items.filter(item =>
        item && typeof item[field] === 'string' && selectedValues.includes(item[field].toLowerCase())
      );
    }

    if (typeof searchText === 'string') {
      searchText = searchText.toLowerCase();
      return items.filter(item =>
        item && typeof item[field] === 'string' && item[field].toLowerCase().includes(searchText)
      );
    }

    return items;
  }
}
